import { Backdrop, CircularProgress, Typography, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../state/store";
import { useEffect } from "react";

const PageLoad: React.FC = () => {
    const appState = useSelector((state: RootState) => state.appSlice);
    const theme = useTheme();

    useEffect(() => {
        if (appState.loadingState.loading) {
            document.onkeydown = function (event) { event.preventDefault() }
        }
        else {
            document.onkeydown = function () { }
        }
    }, [appState.loadingState.loading]);
    
    return (
        <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: "rgba(0, 0, 0, 0.5)", display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            open={appState.loadingState.loading}
        >
            <div className="modalUpdateProgress" >
                <div className="loader" >
                </div>
            </div>
            {appState.loadingState.loadingMessage && appState.loadingState.loadingMessage.length > 0 &&
                <Typography variant="h6" sx={{ marginTop: 2, color: theme.palette.secondary.main }}>
                    {appState.loadingState.loadingMessage}
                </Typography>
            }
        </Backdrop>
    )
}

export default PageLoad;